export default __webpack_public_path__ + "static/media/totalCollections.5cbd9259.svg";